import { cleanEnv, str } from "envalid";

export const env = cleanEnv(process.env, {
  NODE_ENV: str({ default: "development" }),
  REACT_APP_RECAPTCHA_SITE_KEY: str({ default:"nan" }),
});
